import { render } from "./ActivityNewUpdateDialog.vue?vue&type=template&id=64cdae8c"
import script from "./ActivityNewUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ActivityNewUpdateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__